import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from './locales/en';
import ko from './locales/ko';


const resources = { en, ko };

i18n
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3', //Add this line
    resources,
    lng: 'ko',
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n
  